exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h3.header-text{margin:2em 0 1em}.help-block{text-align:left}.btn-reset-password{display:block;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules?sourceMap!./core/reset-password/reset-password.useable.css
// module id = 775
// module chunks = 0